import { Clock } from "lucide-react";
import type { ReactNode } from "react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface Props {
  titolo: string;
  descrizione?: string | null;
  placeholder?: boolean;
  azioniHeader?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function WidgetCard({
  titolo,
  descrizione,
  placeholder,
  azioniHeader,
  children,
  className,
}: Props) {
  return (
    <section
      className={cn(
        "rounded-xl border bg-card/60 p-5 space-y-3",
        placeholder && "border-dashed bg-muted/20",
        className
      )}
    >
      <header className="flex items-start justify-between gap-3">
        <div className="space-y-0.5">
          <h2 className="text-sm font-semibold tracking-tight flex items-center gap-2">
            {titolo}
            {placeholder && (
              <Badge
                variant="outline"
                className="text-[10px] gap-1 text-muted-foreground"
              >
                <Clock className="size-3" />
                Prossimamente
              </Badge>
            )}
          </h2>
          {descrizione && (
            <p className="text-xs text-muted-foreground max-w-xl">
              {descrizione}
            </p>
          )}
        </div>
        {azioniHeader}
      </header>
      <div className={cn(placeholder && "opacity-60")}>{children}</div>
    </section>
  );
}
